export const fileName = 'jobscript.sh';
export const target_path_job = '/';
export const target_path_container = '/input';
export const source_path_job = '/';
export const source_path_container = '/output';
export const target_path_app_container_image_dataset = '/';
export const target_path_custom_job_script_dataset = '/';
export const source_path_default_data_output = '/output';
